module.exports = __webpack_public_path__ + "img/type_01.0dd84077.png";